module.exports = __webpack_public_path__ + "media/images/gallery/constellations/delphinus/del_vis-a94c2c8b4f94b53af3091c54318dbcbc.jpg";